/** Parse YouTube-like t=90 / t=1m30s / #t=90 from location or config */
export function parseTimeParam(raw: string | null | undefined): number | null {
  if (!raw) return null
  const s = raw.trim()
  if (!s) return null
  if (/^\d+(\.\d+)?$/.test(s)) return Number(s)
  const m = s.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/i)
  if (m) {
    const h = Number(m[1] || 0)
    const min = Number(m[2] || 0)
    const sec = Number(m[3] || 0)
    return h * 3600 + min * 60 + sec
  }
  return null
}

export function readStartTimeFromLocation(): number | null {
  if (typeof window === 'undefined') return null
  try {
    const q = new URLSearchParams(window.location.search).get('t')
    const fromQuery = parseTimeParam(q)
    if (fromQuery != null) return fromQuery
    const hash = window.location.hash.replace(/^#/, '')
    const params = new URLSearchParams(hash.includes('=') ? hash : `t=${hash.replace(/^t=/, '')}`)
    return parseTimeParam(params.get('t'))
  } catch {
    return null
  }
}

export function resolveInitialStartTime(configStart?: number): number {
  const fromLoc = readStartTimeFromLocation()
  if (fromLoc != null && fromLoc > 0) return fromLoc
  if (typeof configStart === 'number' && configStart > 0) return configStart
  return 0
}
